export default "__VITE_ASSET__UrSXVHcn__"